import React from 'react';
import { AvatarContainer, AvatarImage, AvatarInitials } from './Avatar.styled';
import { IAvatar } from '../../../@types/avatar';
import { getItem } from '../../../../utils/localStorage';

export function Avatar ({ imageSrc, alt = 'Avatar', size = '100%' }: IAvatar) {
  const { user, userProfile } = getItem('user');
  const getUserNameInitials = () => {
    if (user) {
      return `${user.userFirstName.charAt(0).toUpperCase()}${user.userLastName.charAt(0).toUpperCase()}`;
    } else if (userProfile) {
      return `${userProfile.userFirstName.charAt(0).toUpperCase()}${userProfile.userLastName.charAt(0).toUpperCase()}`;
    } else {
      return '';
    }
  };

  return (
    <AvatarContainer size={size}>
      {imageSrc ? (
        <AvatarImage src={imageSrc} alt={alt} />
      ) : (
        <AvatarInitials>{getUserNameInitials()}</AvatarInitials>
      )}
    </AvatarContainer>
  );
}

export default Avatar;
